import { Box, Typography } from '@mui/material'
import { SalesRankingRow } from '../../../DTO/GLItemsDTO'

const euro = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})

export default function SalesRankingList(props: {
  title: string
  rows: SalesRankingRow[]
  emptyText?: string
}) {
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: 1,
        padding: 2,
        minHeight: 180,
      }}
    >
      <Typography variant="h6" component="h3" sx={{ marginBottom: 1.5 }}>
        {props.title}
      </Typography>
      {props.rows.length === 0 && (
        <Box sx={{ color: '#666' }}>{props.emptyText || 'Keine Einträge'}</Box>
      )}
      {props.rows.map(row => (
        <Box
          key={row.id}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 1,
            paddingY: 0.75,
            borderBottom: '1px solid #eee',
          }}
        >
          <Box>{row.name}</Box>
          <Box sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{euro.format(row.value)}</Box>
        </Box>
      ))}
    </Box>
  )
}
